import { Card } from "components/styles";
import styled from "styled-components";

export const Wrapper = styled(Card)`
  text-align: left;
  margin-bottom: 2rem;
`;

export const Heading = styled.p`
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
`;

export const Description = styled.p``;

export const DescriptionLabel = styled.label`
  font-weight: 600;
  margin-right: 0.5rem;
`;
